export default "__VITE_PUBLIC_ASSET__d528b127__"